<template>
  <div class="mainContainer">
    <v-container grid-list-xs class="mb-5">
      <v-flex xs12 sm10 md8 lg6 class="mx-auto">
        <v-card
          color="transparent"
          flat
          class="px-2 text-xs-center"
          v-if="content"
        >
          <v-card-title primary-title class="py-0">
            <h1 class="display-1 mx-auto">
              {{ content.title }}
            </h1>
          </v-card-title>
          <v-layout row wrap>
            <v-btn
              v-show="!scanQR"
              color="switchq lighten-1 text--accent-1"
              :loading="loading"
              @click="scanQR = true"
              dark
              class="my-3 qrBTN"
              >{{ !scanQR ? content.scan : content.cancel }}
              <Icon icon="scanIcon" v-if="!scanQR" iconClass="ms-2" />
            </v-btn>
          </v-layout>
          <v-expand-transition>
            <v-alert
              :value="error"
              color="error"
              :icon="warning"
              outlined
              class="mb-3"
            >
              {{ error }}
            </v-alert>
          </v-expand-transition>
          <v-form @submit.prevent="submit()" ref="form">
            <input type="password" id="fake" />
            <v-text-field
              v-model="form.name"
              :label="content.name"
              :rules="[rules.name]"
            ></v-text-field>
            <v-text-field
              type="text"
              v-model="form.identifier"
              @keyup="uppercase"
              :label="content.uid"
              :rules="[rules.switch]"
              mask="NNNNNNNNNNNNNNNN"
            ></v-text-field>
            <span class="red--text" v-if="errors && errors.switch">{{
              content.validation.uid
            }}</span>
            <v-text-field
              :type="showp ? 'text' : 'password'"
              v-model="form.password"
              :label="content.password"
              :rules="[rules.password]"
              :append-icon="showp ? eye : eyeOff"
              @click:append="showp = !showp"
            ></v-text-field>
            <!-- <v-text-field
              type="text"
              v-model="form.ip"
              :label="content.ip"
              :rules="[rules.ip]"
            ></v-text-field> -->
            <!-- <v-layout row wrap>
              <v-flex d-flex shrink align-center align-content-center>
                <span class="title">{{ content.ip }}:</span>
              </v-flex>
              <v-flex shrink>
              </v-flex>
            </v-layout> -->
            <div class="qrBox" v-if="scanQR">
              <qr-modal
                :activator="scanQR"
                @close="scanQR = false"
                @setMac="setMac"
              />
            </div>
            <v-btn
              color="switchq lighten-1 text--accent-1"
              :loading="loading"
              block
              type="submit"
              dark
              class="mt-3"
              >{{ content.submit }}</v-btn
            >
          </v-form>
        </v-card>
      </v-flex>
    </v-container>
  </div>
</template>
<script>
import axios from "@/plugins/axios";
import Lang from "@/helpers/lang";
import { mdiAlert, mdiEyeOff, mdiEye } from "@mdi/js";
import QrModal from "@/components/general/QrModal.vue";
export default {
  name: "NewGateway",
  components: {
    QrModal,
  },
  data() {
    return {
      warning: mdiAlert,
      eyeOff: mdiEyeOff,
      eye: mdiEye,
      form: {
        name: "",
        identifier: "",
        password: "",
        // ip: "",
      },
      rules: {
        name: (v) => !v || v.length <= 25 || this.content.validation.name,
        // ip: (v) => !!v || this.content.validation.ip,
        switch: (v) => !!v || this.content.validation.uid,
        password: (v) =>
          (v && v.length >= 6) || this.content.validation.password,
      },
      scanQR: false,
      showp: false,
      locale: null,
      content: {},
      errors: {},
      error: null,
      loading: false,
    };
  },
  created() {
    this.locale = Lang.get();
    this.setLang();
  },
  // watch: {
  //   form() {
  //     this.form.identifier = this.form.identifier.toUpperCase();
  //   },
  // },
  mounted() {
    let mac = this.$route.query.mac || null;
    let name = this.$route.query.name || null;
    if (mac) this.form.identifier = mac;
    if (name) this.form.name = name;
  },
  methods: {
    uppercase() {
      this.form.identifier = this.form.identifier.toUpperCase();
    },
    submit() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        axios
          .post(`/gateways/new`, this.form)
          .then((res) => {
            this.loading = false;
            console.log(res.data);
            // this.$store.dispatch("devices/setDevice", res.data.device);
            // this.$store.dispatch("devices/fetchDevices");
            this.$store.dispatch("general/setAlert", {
              type: "success",
              msg: "device-added",
            });
            this.$router.push("/devices");
          })
          .catch((err) => {
            this.loading = false;
            if (err.response.data.message === "exists") {
              this.error = this.content.exists;
            } else {
              this.error = this.content.error;
            }
            this.loading = false;
          });
      }
    },
    setMac(mac) {
      this.form.identifier = mac;
      this.scanQR = false;
    },
    setLang() {
      if (this.locale == "en") {
        this.content = {
          scan: "Scan gateway's QR",
          title: "Add A New Unit",
          name: "Unit's Name (optional)",
          uid: "Unit's ID",
          password: "password",
          submit: "Create",
          ip: "IP address",
          controller: "Controller",
          sensors: "Sensors",
          validation: {
            name: "The name can't be longer than 25 characters",
            uid: "Unit's ID is required",
            ip: "Unit's IP address is required",
            password: "Password must be at least 8 characters",
          },
          error: "Unit's ID or Password are incorrect",
          exists: "You have already registered this unit",
          cancel: "Close scanner",
        };
      } else if (this.locale == "he") {
        this.content = {
          scan: "סריקת מרכזיה",
          title: "הוסף מרכזיה חדש",
          name: "שם מרכזיה (אפשרי)",
          uid: "מספר המרכזיה",
          password: "סיסמה",
          submit: "שלח",
          ip: "כתובת IP",
          controller: "בקר",
          sensors: "חיישנים",
          validation: {
            name: "שם המרכזיה לא יכול להיות ארוך 25 תווים",
            uid: "חובה להזין את מספר המרכזיה",
            password: "הסיסמא חייבת להיות לפחות 8 תווים",
            ip: "חובה להזין את כתובת הIP",
          },
          error: "מספר המרכזיה או הסיסמה אינם נכונים",
          exists: "המרכזיה הזה כבר רשום אצלך",
          cancel: "סגירת סורק",
        };
      }
    },
  },
};
</script>
<style lang="scss" scoped>
#fake {
  position: absolute;
  top: -15000px;
}

.qrBTN {
  margin: 0 auto;
}
// .qrBox {
//   border: 1px solid red;
// }
</style>
